import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { ServiceCard } from '../components/ServiceCard';
import { AnimateOnScroll } from '../components/AnimateOnScroll';
import { Button } from '../components/ui/button';
import { servicesData } from '../data/mock';

const BOOKING_URL = "https://outlook.office.com/book/SAADINFORMATIQUE1@saad-informatique.fr/?ismsaljsauthenabled";

export const Services = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 relative overflow-hidden">
      {/* Décors d'ambiance subtils */}
      <div className="absolute top-40 -left-20 w-72 h-72 bg-gradient-to-br from-blue-200/20 to-cyan-200/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-[600px] -right-20 w-80 h-80 bg-gradient-to-br from-orange-200/20 to-pink-200/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-40 left-1/3 w-96 h-96 bg-gradient-to-br from-purple-200/15 to-blue-200/15 rounded-full blur-3xl pointer-events-none" />

      {/* Hero */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-cyan-50 relative">
        <div className="mx-auto max-w-4xl text-center relative z-10">
          <AnimateOnScroll>
            <span className="inline-block px-4 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-4">
              Mes prestations
            </span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Services sur mesure pour votre informatique
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed">
              Chaque client est unique. C'est pourquoi je ne propose pas d'offres packagées ni de tarifs affichés. 
              Toutes mes prestations sont adaptées à votre contexte, votre taille d'entreprise et vos enjeux réels.
            </p>
          </AnimateOnScroll>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="mx-auto max-w-7xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {servicesData.map((service, index) => (
              <AnimateOnScroll key={service.id} delay={index * 80}>
                <ServiceCard service={service} />
              </AnimateOnScroll>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-blue-50 relative z-10">
        <div className="mx-auto max-w-3xl text-center">
          <AnimateOnScroll>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              Vous ne trouvez pas exactement ce que vous cherchez ?
            </h2>
            <p className="text-base sm:text-lg text-gray-600 mb-8">
              Chaque situation est différente. Parlons de votre besoin spécifique.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <Button asChild size="lg" className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white shadow-lg">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
                  <Phone className="w-5 h-5 mr-2" />
                  Prendre rendez-vous
                </a>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50">
                <Link to="/contact">
                  Me contacter
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Link>
              </Button>
            </div>
          </AnimateOnScroll>
        </div>
      </section>
    </div>
  );
};
